'use client';

import ChimeKitIcon from 'components/shared/LinkWithIcon/ChimeKitIcon';
import ThreadsIcon from 'public/icons/social-threads.svg';
import { ShareButtonProps } from './types';

const ShareButton = ({ name, link, testId }: ShareButtonProps) => {
  const shareTo = () => {
    const shareLink = link;
    window.open(shareLink, '_blank', 'width=600,height=400');
  };

  return (
    <button
      onClick={shareTo}
      data-testid={testId}
      className="flex justify-center items-center w-8 h-8 dark-green-colorway hover:medium-green-colorway rounded-full transition duration-300">
      <span className="sr-only">Share on {name}</span>
      {name !== 'Threads' && (
        <ChimeKitIcon
          iconName={name}
          className="block w-auto h-4 fill-white hover:fill-primary transition duration-300"
        />
      )}
      {name === 'Threads' && (
        <ThreadsIcon className="block w-auto h-4 fill-white hover:fill-primary transition duration-300" />
      )}
    </button>
  );
};

export default ShareButton;
